import React from 'react';
import { Star, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Sarah Mitchell",
      role: "Post-Surgery Recovery",
      content: "After my knee surgery, I was worried I'd never get back to running. Vincent's rehabilitation-focused approach got me not just back to running, but stronger than before. His knowledge of corrective exercise made all the difference.",
      rating: 5
    },
    {
      name: "Marcus Johnson",
      role: "Strength Training Client",
      content: "I've worked with several trainers over the years, but Vincent's customized programming is on another level. He addresses muscle imbalances I didn't even know I had. Down 30 lbs and hitting PRs I never thought possible.",
      rating: 5
    },
    {
      name: "Jennifer Lopez",
      role: "Weight Loss Transformation",
      content: "Vincent doesn't just give you a workout — he teaches you why you're doing it. His nutrition guidance combined with smart training helped me lose 45 pounds and keep it off for over a year now. Life-changing experience.",
      rating: 5
    },
    {
      name: "David Chen",
      role: "Youth Athlete (Parent Review)",
      content: "Our son has been training with Vincent for his high school football season. Not only has his performance improved dramatically, but he's learned proper form and injury prevention. Vincent is patient, knowledgeable, and great with teens.",
      rating: 5
    }
  ];

  return (
    <section id="results" className="testimonials-section">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Client Success Stories</span>
          <h2 className="section-title">Real People. Real Results.</h2>
          <p className="section-description">
            Don't just take my word for it — hear from clients who've transformed their lives through dedication and customized programming.
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-quote">
                <Quote size={32} />
              </div>
              <div className="testimonial-stars">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={18} fill="currentColor" />
                ))}
              </div>
              <p className="testimonial-content">{testimonial.content}</p>
              <div className="testimonial-author">
                <h4 className="author-name">{testimonial.name}</h4>
                <p className="author-role">{testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="results-image">
          <img 
            src="https://images.pexels.com/photos/13621287/pexels-photo-13621287.jpeg" 
            alt="Training session demonstrating results"
          />
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
